import ScoreCardItem from './ScoreCardItem';

export default ScoreCardItem;
